module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "join-prompt"
  }, [_c('my-stream'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("content")) + ":\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }, _vm.onInput]
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.isButtonDisabled
    }
  }, [_vm._v(_vm._s(_vm.$t("button_join")))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-382ff846"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/JoinPrompt.vue
// module id = 365
// module chunks = 1